function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#272d4b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 32.877) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.247,0A23.247,23.247,0,1,0,46.495,23.247,23.234,23.234,0,0,0,23.247,0Zm0,43.4A20.148,20.148,0,1,1,43.4,23.247,20.171,20.171,0,0,1,23.247,43.4Z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.223 11.223)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M146.087,134.062h-8.925v-8.925a1.55,1.55,0,0,0-3.1,0v8.925h-8.925a1.55,1.55,0,0,0,0,3.1h8.925v8.925a1.55,1.55,0,0,0,3.1,0v-8.925h8.925a1.55,1.55,0,0,0,0-3.1Z",
  transform: "translate(-123.588 -123.588)"
})));

var SvgMas = function SvgMas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65.753,
    height: 65.753,
    viewBox: "0 0 65.753 65.753",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mas.4ba39cf9.svg";
export { ForwardRef as ReactComponent };